import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({});

export default twMerge;
